module.exports = __webpack_public_path__ + "img/thumbnail_GreySeal_m_normal.ded4b021.png";